import Progress from './progress.vue';
export default Progress;


// WEBPACK FOOTER //
// ./src/components/progress/index.js